import React from 'react'

import { getAttachmentComponent } from '../../attachment-preview'
import { useMessageProperties } from '../message-provider'

export default function MessageAttachments() {
    const { message } = useMessageProperties()

    if (!message.attachments || message.attachments.length === 0) {
        return null
    }

    return (
        <>
            {message.attachments.map((attachment, index) => (
                <React.Fragment
                    key={attachment.id || `${attachment.url}-${index}`}
                >
                    {getAttachmentComponent(attachment)}
                </React.Fragment>
            ))}
        </>
    )
}
